import React, { useEffect, useCallback } from "react";
import { useAppDispatch } from "../../services/hooks";
import {
  Notification as NotificationType,
  removeNotification,
} from "../../services/slices/notification";
import styles from "./Notification.module.scss";

interface NotificationProps {
  notification: NotificationType;
}

export const Notification: React.FC<NotificationProps> = ({ notification }) => {
  const dispatch = useAppDispatch();
  const { id, message, type, autoClose, duration } = notification;

  const handleClose = useCallback(() => {
    dispatch(removeNotification(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (autoClose) {
      const timer = setTimeout(() => {
        handleClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [autoClose, duration, handleClose]);

  return (
    <div className={`${styles.notification} ${styles[type]}`}>
      <div className={styles.content}>
        <span className={styles.message}>{message}</span>
      </div>
      <button className={styles.closeButton} onClick={handleClose}>
        ×
      </button>
    </div>
  );
};
